var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"button toggle",class:[_vm.firstactive ? 'active' : ''],on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.label1))]),_c('button',{staticClass:"button toggle",class:[!_vm.firstactive ? 'active' : ''],on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.label2))])])
}
var staticRenderFns = []

export { render, staticRenderFns }